import { Box, IconButton } from '@mui/material';
import {
    NavigateBefore as NavigateBeforeIcon,
    NavigateNext as NavigateNextIcon,
} from '@mui/icons-material';

type SttPaginationProps = {
    page?: number;
    pages?: number;
    count?: number;
    onChangePage: (page: number) => void;
};

export function SttPagination({
    page = 0,
    pages = 0,
    count = 0,
    onChangePage,
}: SttPaginationProps) {
    // -----| Render |-----
    return (
        <Box className="tw-flex tw-items-center tw-gap-2">
            <IconButton
                disabled={page < 2}
                onClick={() => onChangePage(page - 1)}
            >
                <NavigateBeforeIcon />
            </IconButton>
            <span className="tw-text-sm tw-font-medium tw-text-gray-700">
                {page} / {pages} [ {count} ]
            </span>
            <IconButton
                disabled={page >= pages}
                onClick={() => onChangePage(page + 1)}
            >
                <NavigateNextIcon />
            </IconButton>
        </Box>
    );
}
